module.exports = __webpack_public_path__ + "media/images/gare à proximité-072190cc665cdf8bab69f0263b4bd479.svg";